// "Sign in with Google" (Google Identity Services). Only the public client id is needed: the button returns a
// Google-signed ID token that the API verifies. There is no client secret in the browser.
export const GOOGLE_CLIENT_ID = (process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '').trim();
